import {
  AnalyticsEvent,
  Maybe,
  ProductOfferCardActionResult,
  ProductOfferCardActionResultTypenames,
  RouteNavigationAction,
} from '@varo/graphql-schema-types';
import { Href, ImperativeRouter } from 'expo-router';
import { parseGQLAnalyticsEvent } from 'services/analytics/helpers/parseGQLAnalyticsEvent';
import { SegmentInterface } from 'services/analytics/segment/types';
import { PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';

export enum Origin {
  HOME = 'HOME',
  MY_VARO = 'MY_VARO',
}

const getProductOfferCardActionResultRouteData = (
  action: Maybe<ProductOfferCardActionResult>,
): {
  route: string;
  analyticsEventProps?: PressableAnalyticsProps;
  analyticsEvent: Maybe<AnalyticsEvent> | undefined;
  usePushNavigation: boolean;
} => {
  let analyticsEventProps: PressableAnalyticsProps | undefined = undefined;
  let pathName = '';
  let analyticsEvent: Maybe<AnalyticsEvent> | undefined = undefined;
  let usePushNavigation = true;

  switch (action?.__typename) {
    case ProductOfferCardActionResultTypenames.RouteNavigationAction:
      pathName = (action as RouteNavigationAction).route;
      analyticsEvent = (action as RouteNavigationAction).analyticsEvent;
      usePushNavigation = false;
      break;
    case ProductOfferCardActionResultTypenames.SDLaunchBelieveTransferFundsNavigation:
      analyticsEventProps = {
        analyticsId: 'believeCardClicked',
      };
      pathName = '/believe/apply';
      break;
    case ProductOfferCardActionResultTypenames.SDLaunchAdvanceOnboardingNavigation:
      analyticsEventProps = {
        analyticsId: 'advanceOnboardingCardClicked',
      };
      pathName = '/varo-advance';
      break;
    case ProductOfferCardActionResultTypenames.SDLaunchAdvanceAccountNavigation: {
      const advanceId = action?.id;
      analyticsEventProps = {
        analyticsId: 'varoAdvanceCardClicked',
      };
      pathName = `/varo-advance?id=${advanceId}`;
      break;
    }
  }
  return {
    route: pathName,
    analyticsEventProps,
    analyticsEvent,
    usePushNavigation,
  };
};

export const handleProductOfferCardActionNavigation = (
  action: ProductOfferCardActionResult,
  router: ImperativeRouter,
  segmentClient: SegmentInterface,
) => {
  const { route, analyticsEvent, usePushNavigation } =
    getProductOfferCardActionResultRouteData(action);
  if (analyticsEvent) {
    const { name, properties } = parseGQLAnalyticsEvent(analyticsEvent);
    void segmentClient.logEvent(name, properties);
  }
  if (usePushNavigation) {
    router.push(route as Href);
  } else {
    router.navigate(route as Href);
  }
};

export default getProductOfferCardActionResultRouteData;
